export enum StaffScheduleDataTestId {
  SlotActionModal = "slotActionModal",
  CreateShiftButton = "createShiftButton",
  DoctorSelect = "doctorSelect",
  WorkPlaceSelect = "workPlaceSelect",
  AcceptingNfzCheckbox = "acceptingNfzCheckbox",
  AcceptingPrivCheckbox = "acceptingPrivCheckbox",
  VisitTypesSelect = "visitTypesSelect",
  DateStartFromInput = "dateStartFromInput",
  TimeFromInput = "timeFromInput",
  TimeToInput = "timeToInput",
  CommentInput = "commentInput",
  SubmitCreateShiftButton = "submitCreateShiftButton",
  PublishShiftsButton = "publishShiftsButton",
  ConfirmPublishShiftsButton = "confirmPublishShiftsButton",
  DeleteShiftButton = "deleteShiftButton",
}
